import React, { useEffect, useRef, useState } from 'react';
import injectIntl from 'common/translate/injectIntl';
import { AuthContext, PriceBookContext } from '../../../Context';
import SectionsNavigationItem from './SectionsNavigationItem';

function SectionsNavigation({
  sectionsList,
  intl,
  isSpiffVisible,
  isRental,
  isLeaseOptionAvailable,
  onSelectCallback,
  onSelectGeneralSectionItemCallback,
}) {
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const listRef = useRef(null);

  const toggleNavigation = event => {
    setIsNavigationOpen(!isNavigationOpen);
  };

  const closeNavigation = () => {
    setIsNavigationOpen(false);
  };

  const openNavigation = () => {
    setIsNavigationOpen(true);
  };

  const getNavList = () => {
    const listMap = new Map();

    const allIds = Object.entries(sectionsList).map(([key, item]) => {
      listMap.set(item.id, key);
      return item.id;
    });

    const existingOrderedIds = Array.from(document.querySelectorAll(allIds.map(id => `#${id}`).join(','))).map(
      element => element.id
    );

    return existingOrderedIds.map(id => {
      const key = listMap.get(id);

      if (
        (key === 'spiff' && !isSpiffVisible) ||
        (key === 'rentalInfo' && (!isRental || !AuthContext.model.hasInternalPermissions)) ||
        (key === 'leaseOption' && !isLeaseOptionAvailable) ||
        (key === 'adminSection' && !AuthContext.model.hasSalesOpsPermissions) ||
        (key === 'daasSettingsSection' && PriceBookContext.model.isSupportsSwitchvoxSIPStation)
      ) {
        return null;
      }

      const { title, isGeneralSection } = sectionsList[key];

      return (
        <SectionsNavigationItem
          key={`nav-item-${key}`}
          id={id}
          isGeneralSection={isGeneralSection}
          title={intl.formatMessage({ id: title })}
          onSelectGeneralSectionItemCallback={onSelectGeneralSectionItemCallback}
          onSelectCallback={onSelectCallback}
          closeNavigation={closeNavigation}
          listRef={listRef}
        />
      );
    });
  };

  useEffect(() => {
    if (isNavigationOpen) {
      listRef.current.firstChild.focus();
    }
  }, [isNavigationOpen]);

  return (
    <div className="sections-navigation" onFocus={openNavigation}>
      <button
        title={intl.formatMessage({ id: 'msg_navigate_to_section' })}
        className="square toolbar-btn nav-btn no-bg"
        onClick={toggleNavigation}
      >
        <span className="icon-menu" />
      </button>

      {isNavigationOpen && (
        <>
          <div className="navigation-list" ref={listRef}>
            {getNavList()}
          </div>
          <div className="close-navigation-overlay" onClick={closeNavigation}></div>
        </>
      )}
    </div>
  );
}

export default injectIntl(SectionsNavigation);
